import React, { use } from 'react';
import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import TravelForm from './TravelForm';
import { useNavigate } from 'react-router-dom';

export default function SetDestinationButton({ onClick, currentLocation, ...props }) {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();

    return (
        <span>
            <Button disabled={!props.account || props.disabled} variant={props.as ? 'text' : 'contained'} onClick={() => setOpen(true)} color="primary">
                {(props.label || 'Set Destination')}
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Set Your Destination</DialogTitle>
                <DialogContent>
                    <TravelForm
                        currentLocation={currentLocation}
                        destinationOnly={true} 
                        basic={true} 
                        client={props.client} 
                        account={props.account} 
                        onSave={travel => {
                            if (props.redirect !== false) {
                                navigate(`/drive/${travel.id}`);
                            } else {
                                setOpen(false)
                            }
                        }}
                        />
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={() => setOpen(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </span>
    );
}
